import React from "react";
import { useLang } from "../LanguageContext";
import { RESTAURANT } from "../restaurant.config";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#EBE7DD] text-[#23211E] py-16 px-6 md:px-10 border-t border-[#23211E]/10"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <p className="font-serif text-3xl md:text-4xl leading-none">
            Grappolo <span className="italic text-[#B85532]">d'Oro</span>
          </p>
          <p className="mt-3 text-xs uppercase tracking-[0.3em] text-[#565F41]">
            {t.footer.tagline} · {t.footer.since}
          </p>
        </div>
        <div className="col-span-6 md:col-span-3 text-sm font-light space-y-1 text-[#3D3A35]">
          <p>{RESTAURANT.address.street}</p>
          <p>
            {RESTAURANT.address.cap} {RESTAURANT.address.city} ({RESTAURANT.address.province})
          </p>
          <p>{RESTAURANT.email}</p>
          <p>{RESTAURANT.mobileDisplay}</p>
        </div>
        <div className="col-span-6 md:col-span-4 md:text-right text-xs text-[#565F41] font-light space-y-1">
          <p>© {year} Grappolo d'Oro</p>
          <p>{t.footer.pIva}</p>
          <p>{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
